<template>
  <div style="padding: 20px 0 0 0">
    <el-form :inline="true" :model="formInline" label-position="left" @keydown.native.enter="onSubmit"
      class="demo-form-inline">
      <el-form-item label="批次号(源)：">
        <el-input maxlength='50' v-model="formInline.pkgCode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="批次号(新)：">
        <el-input maxlength='50' v-model="formInline.newPkgCode" placeholder="请输入"></el-input>
      </el-form-item>
      <el-form-item label="创建时间：">
        <el-date-picker v-model="formInline.createDate" type="datetimerange" range-separator="至" start-placeholder="开始时间"
          @change="timeChange" :default-time="['00:00:00', '23:59:59']" end-placeholder="结束时间"> </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import moment from "moment"
export default {
  name: "InterForm",
  props: {
  },
  data() {
    return {
      formInline: {
        pkgCode: "",
        newPkgCode: "",
        createDate: null,
        createStartTime: null,
        createEndTime: null,
      },
    };
  },
  created() {
    this.$emit("querySubmit", this.formInline);
  },
  methods: {
    timeChange: function (val) {
      if (!val) {
        this.formInline.createStartTime = null;
        this.formInline.createEndTime = null;
        return;
      }
      this.formInline.createStartTime = moment(val[0]).format("YYYY-MM-DD HH:mm:ss");
      this.formInline.createEndTime = moment(val[1]).format("YYYY-MM-DD HH:mm:ss");
    },
    onSubmit: function (e, type = "") {
      this.$emit("querySubmit", this.formInline);
    },
    restSubmit: function () {
      Object.keys(this.formInline).forEach(key => { console.log(key);this.formInline[key] = undefined })  
      this.onSubmit(undefined, "rest");
    },
  }
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
